import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import React, { useEffect, useState } from 'react';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import questionnaire_icon from "../../../images/Questionnaire_icon.png";
import Header from '../../Includes/Header';
import BackButton from '../../Includes/BackButton';
import { reduxForm, InjectedFormProps } from 'redux-form';
import { setwizardPageNumber, setQuestionnaireScreen4 } from '../../authslice';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { ToastBox } from 'MyComponents/Toaster';
import { useTranslation } from 'react-i18next';
import { updatePersonalKycDraftStep } from 'Utils/personalKycDraft';
import RadioButton from 'MyComponents/UI/RadioButton';

interface Props { }

const employmentStatuses = [
    { id: 'radio1', label: 'Employed', value: 'Employed' },
    { id: 'radio2', label: 'Unemployed', value: 'Unemployed' },
    { id: 'radio3', label: 'Retired', value: 'Retired' },
    { id: 'radio4', label: 'Student', value: 'Student' },
    { id: 'radio5', label: 'Self Employed', value: 'Self Employed' },
];

const Questionnaire_Screen4: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
    const questionnaireScreen4 = useSelector((state: RootState) => state.auth.questionnaireScreen4);
    const userID = useSelector((state: RootState) => state.auth.userID);

    const [selectedOption, setSelectedOption] = useState<string>('Employed');

    useEffect(() => {
        if (questionnaireScreen4) {
            setSelectedOption(questionnaireScreen4);
        }
    }, [questionnaireScreen4]);

    const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedOption(e.target.value);
    };

    const submitForm = async () => {
        dispatch(setQuestionnaireScreen4(selectedOption));
        dispatch(setwizardPageNumber(page + 1));
        localStorage.setItem('pageNumber', `${page + 1}`);

        if (userID) {
            updatePersonalKycDraftStep(userID, 'questionnaire', { screen4: selectedOption });
            updatePersonalKycDraftStep(userID, 'wizardState', { pageNumber: page + 1 });
        }
    };

    return (
        <>
            <ToastBox />
            <Container fluid className="px-0 px-md-3">
                <Row className="g-0">
                    <Col md={12} className="mx-auto px-2 pt-0 pb-3">
                        <div className="mt-5">
                            <Row className="px-2 px-md-5">
                                <Col md={12}><BackButton /></Col>
                            </Row>
                            <Row className="px-2 px-md-5">
                                <Col md={12}>
                                    <div className="d-flex align-items-start py-3">
                                        <img src={questionnaire_icon} width={48} className="d-none d-md-block me-3 mt-1" alt="Questionnaire Icon" />
                                        <div>
                                            <h3 className="text-start m-0">{t('kyc.questionnaire')}</h3>
                                            <p className="fw-normal text-secondary m-0 mt-1 text-nowrap">{t('kyc.individual_form')}</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="px-2 px-md-5">
                                <Col md={12}>
                                    <div className="d-none d-md-flex align-items-center">
                                        <ProgressBar variant="primary" className="custom_progressbar mr-2" now={40} />
                                        <p className="fw-bold small py-3 px-3 m-0">4/7</p>
                                    </div>
                                    <p className="fw-bold text-start mt-4 m-0">{t('kyc.employment_q')}</p>
                                    <p className="text-secondary text-start small mt-1">{t('kyc.q4_desc')}</p>

                                    <Form noValidate onSubmit={handleSubmit(submitForm)}>
                                        <Row className='mt-4 text-start'>
                                            {employmentStatuses.map((status) => (
                                                <Col md={2} key={status.id} style={{ width: '135px' }}>
                                                    <RadioButton
                                                        id={status.id}
                                                        label={status.label}
                                                        value={status.value}
                                                        checked={selectedOption === status.value}
                                                        onChange={handleRadioChange}
                                                    />
                                                </Col>
                                            ))}
                                        </Row>

                                        <Row className="mt-4 text-start">
                                            <Col md={8}>
                                                <Button type="submit" className="btn btn-primary rounded-5" style={{ width: "220px" }}>
                                                    {t('common.next')}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
})(Questionnaire_Screen4);

export default connect(null)(form);
